import Index from '@/views/public/welcome.vue'

export default [
  {
    path: '/',
    name: '/',
    component: Index,
    meta: {
      title: '总览',
      keepAlive: false
    }
  },
  {
    path: '/admin/',
    name: 'admin',
    component: Index,
    meta: {
      title: '总览',
      keepAlive: false
    }
  },
  {
    path: '/admin/index',
    name: 'Index',
    component: Index,
    meta: {
      title: '总览',
      keepAlive: false
    }
  },
  {
    path: '/admin/apply/index',
    name: 'ApplyIndex',
    component: () => import("@/views/public/apply_index"),
    meta: {
      title: '应用中心',
      keepAlive: false
    }
  },
  {
    path: '/admin/apply/create_apply',
    name: 'CreateApply',
    component: () => import("@/views/public/create_apply"),
    meta: {
      title: '创建应用',
      keepAlive: false
    }
  },
  {
    path: '/admin/device/home',
    name: 'PublicDeviceHome',
    component: () => import("@/views/public/device_home"),
    meta: {
      title: '设备数据',
      keepAlive: true
    }
  },
  {
    path: '/admin/device/mechanism_device_home',
    name: 'PublicMechanismDeviceHome',
    component: () => import("@/views/public/mechanism_device_home"),
    meta: {
      title: '设备数据',
      keepAlive: true
    }
  },
  {
    path: '/admin/public/w7_login',
    name: 'PublicW7',
    component: () => import("@/views/public/w7CeShi"),
    meta: {
      title: '首页',
      keepAlive: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/public.js